import { AuthError } from "./errors";

const BASE64URL_PATTERN = /^[A-Za-z0-9_-]*$/;
const textDecoder = new TextDecoder();
const textEncoder = new TextEncoder();

export function base64UrlToBytes(input: string): Uint8Array {
  if (typeof input !== "string" || !BASE64URL_PATTERN.test(input)) {
    throw new AuthError("invalid_base64url", "JWT contains invalid Base64URL data");
  }

  const paddingLength = (4 - (input.length % 4)) % 4;
  const base64 = `${input.replace(/-/g, "+").replace(/_/g, "/")}${"=".repeat(paddingLength)}`;

  try {
    const binary = globalThis.atob(base64);
    const bytes = new Uint8Array(binary.length);

    for (let index = 0; index < binary.length; index += 1) {
      bytes[index] = binary.charCodeAt(index);
    }

    return bytes;
  } catch {
    throw new AuthError("invalid_base64url", "JWT contains invalid Base64URL data");
  }
}

export function base64UrlToString(input: string): string {
  return textDecoder.decode(base64UrlToBytes(input));
}

export function bytesToBase64Url(bytes: Uint8Array): string {
  let binary = "";

  for (let index = 0; index < bytes.length; index += 0x8000) {
    const chunk = bytes.subarray(index, index + 0x8000);
    binary += String.fromCharCode(...chunk);
  }

  return globalThis
    .btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/g, "");
}

export function stringToBase64Url(value: string): string {
  return bytesToBase64Url(textEncoder.encode(value));
}
